/*
  Fremont Fashion — quick view for collection product cards
  Theme: Refresh (Dawn-based)

  Loaded by sections/main-collection-product-grid.liquid.

  This injects its own button into each card rather than requiring an edit to
  snippets/card-product.liquid — the product handle is read off the card's
  existing product link. It also builds its own modal on the fly, so there is
  no extra section markup to maintain.

  Product data comes from /products/{handle}.js, Shopify's built-in product
  JSON, so no alternate product template is needed.
*/
(function () {
  'use strict';

  if (window.FremontCollectionQuickView) return;
  window.FremontCollectionQuickView = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

  var formatter;
  try {
    formatter = new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: 'currency',
      currency: CURRENCY,
    });
  } catch (e) {
    formatter = null;
  }

  function money(cents) {
    var amount = cents / 100;
    return formatter ? formatter.format(amount) : amount.toFixed(2) + ' ' + CURRENCY;
  }

  function sized(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function summarise(html, limit) {
    var div = document.createElement('div');
    div.innerHTML = html || '';
    var text = (div.textContent || '').replace(/\s+/g, ' ').trim();
    return text.length > limit ? text.slice(0, limit).trim() + '…' : text;
  }

  function escapeAttr(value) {
    return String(value || '').replace(/"/g, '&quot;');
  }

  var EYE =
    '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false">' +
    '<path d="M2 12s3.8-6.5 10-6.5S22 12 22 12s-3.8 6.5-10 6.5S2 12 2 12Z" stroke-linejoin="round"/>' +
    '<circle cx="12" cy="12" r="2.8"/></svg>';

  /* ------------------------------ button injection ---------------------- */

  function handleFrom(href) {
    var match = /\/products\/([^/?#]+)/.exec(href || '');
    return match ? match[1] : null;
  }

  function inject(scope) {
    (scope || document).querySelectorAll('.ff-collection .card-wrapper').forEach(function (card) {
      if (card.dataset.ffQuickBound === 'true') return;

      var link = card.querySelector('a[href*="/products/"]');
      var handle = link && handleFrom(link.getAttribute('href'));
      if (!handle) return;

      card.dataset.ffQuickBound = 'true';

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ff-quick';
      button.setAttribute('data-ff-quick', handle);
      button.title = 'Quick view';
      button.setAttribute('aria-label', 'Quick view');
      button.innerHTML = EYE;

      card.appendChild(button);
    });
  }

  /* ---------------------------------- modal ----------------------------- */

  var modal = null;
  var modalBody = null;
  var lastFocus = null;
  var cache = {};

  function buildModal() {
    if (modal) return;

    modal = document.createElement('div');
    modal.className = 'fqv fqv--ff';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="fqv__backdrop" data-ff-qv-close></div>' +
      '<div class="fqv__dialog" role="dialog" aria-modal="true" aria-label="Product quick view">' +
      '<button type="button" class="fqv__close" data-ff-qv-close aria-label="Close quick view">' +
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button><div class="fqv__body" data-ff-qv-body></div></div>';

    document.body.appendChild(modal);
    modalBody = modal.querySelector('[data-ff-qv-body]');

    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-ff-qv-close]')) close();
    });

    modal.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var focusables = modal.querySelectorAll(
        'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    modal.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-ff-qv-form]');
      if (!form) return;
      event.preventDefault();
      addToCart(form);
    });
  }

  function open() {
    buildModal();
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('fqv-open');
    var closer = modal.querySelector('.fqv__close');
    if (closer) closer.focus();
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('fqv-open');
    modalBody.innerHTML = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* -------------------------------- add to cart ------------------------- */

  function refreshCart() {
    fetch(ROOT + 'cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document
          .querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"]')
          .forEach(function (el) {
            el.textContent = cart.item_count;
          });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {});
  }

  function addToCart(form) {
    var button = form.querySelector('[data-ff-qv-submit]');
    var note = form.querySelector('[data-ff-qv-note]');
    if (!button || button.disabled) return;

    var original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Could not add');
          return data;
        });
      })
      .then(function () {
        button.textContent = 'Added';
        refreshCart();
        // Confirm briefly, then get out of the way.
        setTimeout(close, 850);
      })
      .catch(function (error) {
        button.disabled = false;
        button.textContent = original;
        if (note) note.textContent = error.message;
      });
  }

  /* --------------------------------- render ----------------------------- */

  function variantFor(product, chosen) {
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      var match = true;
      for (var j = 0; j < chosen.length; j++) {
        if (variant.options[j] !== chosen[j]) {
          match = false;
          break;
        }
      }
      if (match) return variant;
    }
    return null;
  }

  function paintVariant(product) {
    var selects = modalBody.querySelectorAll('[data-ff-qv-option]');
    var chosen = Array.prototype.map.call(selects, function (s) {
      return s.value;
    });
    var variant = selects.length ? variantFor(product, chosen) : product.variants[0];

    var idField = modalBody.querySelector('[data-ff-qv-id]');
    var priceEl = modalBody.querySelector('[data-ff-qv-price]');
    var button = modalBody.querySelector('[data-ff-qv-submit]');

    if (!variant) {
      if (button) {
        button.disabled = true;
        button.textContent = 'Unavailable';
      }
      return;
    }

    if (idField) idField.value = variant.id;

    if (priceEl) {
      priceEl.innerHTML =
        '<span>' +
        money(variant.price) +
        '</span>' +
        (variant.compare_at_price > variant.price ? '<s>' + money(variant.compare_at_price) + '</s>' : '');
    }

    if (button) {
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }

    if (variant.featured_image && variant.featured_image.src) {
      var main = modalBody.querySelector('[data-ff-qv-main]');
      if (main) main.src = sized(variant.featured_image.src, 800);
    }
  }

  function render(product) {
    var images = product.images || [];

    var optionsHtml = '';
    if (product.variants.length > 1) {
      optionsHtml = product.options
        .map(function (option, index) {
          var name = typeof option === 'string' ? option : option.name;
          var values = typeof option === 'string' ? [] : option.values;

          if (!values.length) {
            // Older product.js payloads list option names only — rebuild the
            // value set from the variants themselves.
            var seen = {};
            product.variants.forEach(function (variant) {
              var value = variant.options[index];
              if (value && !seen[value]) seen[value] = true;
            });
            values = Object.keys(seen);
          }

          var list = values
            .map(function (value) {
              return '<option value="' + escapeAttr(value) + '">' + value + '</option>';
            })
            .join('');

          return (
            '<div class="fqv__field">' +
            '<label class="fqv__label" for="ffqv-opt-' + index + '">' + name + '</label>' +
            '<select class="fqv__select" id="ffqv-opt-' + index + '" data-ff-qv-option>' + list + '</select>' +
            '</div>'
          );
        })
        .join('');
    }

    var thumbs = images
      .slice(0, 6)
      .map(function (src, i) {
        return (
          '<button type="button" class="fqv__thumb" data-ff-qv-thumb aria-current="' +
          (i === 0 ? 'true' : 'false') +
          '"><img src="' + sized(src, 160) + '" alt="" loading="lazy"></button>'
        );
      })
      .join('');

    modalBody.innerHTML =
      '<div class="fqv__grid">' +
      '<div class="fqv__gallery">' +
      '<div class="fqv__main"><img data-ff-qv-main src="' + (images[0] ? sized(images[0], 800) : '') +
      '" alt="' + escapeAttr(product.title) + '"></div>' +
      (images.length > 1 ? '<div class="fqv__thumbs">' + thumbs + '</div>' : '') +
      '</div>' +
      '<div class="fqv__details">' +
      '<h3 class="fqv__title">' + product.title + '</h3>' +
      '<div class="fqv__price" data-ff-qv-price></div>' +
      '<p class="fqv__desc">' + summarise(product.description, 260) + '</p>' +
      (optionsHtml ? '<div class="fqv__options">' + optionsHtml + '</div>' : '') +
      '<form data-ff-qv-form>' +
      '<input type="hidden" name="id" value="" data-ff-qv-id>' +
      '<div class="fqv__actions">' +
      '<div class="fqv__field" style="flex:0 0 92px">' +
      '<label class="fqv__label" for="ffqv-qty">Qty</label>' +
      '<input class="fqv__qty" id="ffqv-qty" type="number" name="quantity" value="1" min="1">' +
      '</div>' +
      '<button type="submit" class="ff-btn ff-btn--dark fqv__submit" data-ff-qv-submit>Add to cart</button>' +
      '</div>' +
      '<p class="fqv__note" data-ff-qv-note></p>' +
      '</form>' +
      '<a class="fqv__link" href="' + ROOT + 'products/' + product.handle + '">View full details</a>' +
      '</div></div>';

    modalBody.querySelectorAll('[data-ff-qv-option]').forEach(function (select) {
      select.addEventListener('change', function () {
        paintVariant(product);
      });
    });

    modalBody.querySelectorAll('[data-ff-qv-thumb]').forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        var main = modalBody.querySelector('[data-ff-qv-main]');
        if (main) main.src = sized(images[i], 800);
        modalBody.querySelectorAll('[data-ff-qv-thumb]').forEach(function (other, j) {
          other.setAttribute('aria-current', i === j ? 'true' : 'false');
        });
      });
    });

    paintVariant(product);
  }

  function load(handle) {
    open();
    modalBody.innerHTML = '<div class="fqv__loading">Loading…</div>';

    if (cache[handle]) {
      render(cache[handle]);
      return;
    }

    fetch(ROOT + 'products/' + handle + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('Not found');
        return response.json();
      })
      .then(function (product) {
        cache[handle] = product;
        render(product);
      })
      .catch(function () {
        modalBody.innerHTML =
          '<div class="fqv__loading">Could not load this product. ' +
          '<a class="fqv__link" href="' + ROOT + 'products/' + handle + '">Open the product page</a></div>';
      });
  }

  /* ---------------------------------- boot ------------------------------ */

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ff-quick]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    load(trigger.getAttribute('data-ff-quick'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });

  function boot() {
    inject(document);

    var grid = document.getElementById('ProductGridContainer');
    if (!grid || !window.MutationObserver) return;

    // facets.js rebuilds the grid on every filter change.
    new MutationObserver(function () {
      inject(grid);
    }).observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();